
export const VehicleContainer = ({ vehicles, locations, distances, onChange }) => {
    const getCachedDistance = (p1, p2) => {
        for (let i = 0; i < distances.length; i++) {
            let dist = distances[i];
            if ((dist.fromPlaceId == p1 && dist.toPlaceId == p2) ||
                (dist.fromPlaceId == p2 && dist.toPlaceId == p1)) {
                return dist;
            }
        }
        return null;
    }

    const removeVehicle = (i) => {
        let old = vehicles || [];
        let vehs = [...old];
        vehs.splice(i, 1);
        onChange(vehs);
    }

    const getVehicleCard = (v, ind, from, to, locPercent) => {
        let label = '';
        let pad = <></>;

        if (from > 0) {
            let padWidth = (from * locPercent) + '%';
            pad = <div className="flex" style={{ width: padWidth, height: "10px" }}></div>;
        }

        let del = <i className="pi pi-times-circle mr-1 text-red-600 cursor-pointer text-xl" onClick={() => removeVehicle(ind)}></i>;
        if (v.vehicleVIN && v.vehicleMake && v.vehicleModel &&
            v.vehicleVIN.length > 0 && v.vehicleMake.length > 0 && v.vehicleModel.length > 0) {
            label = `${v.vehicleYear} ${v.vehicleMake} ${v.vehicleModel}`;
        }
        else {
            label = 'Unspecified Vehicle';
        }

        let vehWidth = (((to - from) + 0.5) * locPercent) + '%';
        return <div key={'vehlist.' + ind} className="w-full flex flex-row">
            {pad}
            <div className="mb-0" style={{ width: vehWidth }}>{del} {label}
                <div className="mt-1 w-full arrow"></div>
            </div>
            </div>;

    }

    let locPercent = Math.floor(100 / locations.length);
    let locWidth = locPercent + '%';
    return (<div className="w-full">
        <div className="w-full mb-2">
            <div className="flex flex-row w-full">
                {locations.map((location, i) => {
                    return <div className="text-center p-3" key={'vehloc.' + i} style={{
                        width: locWidth,
                        border: "solid 1px white",
                        backgroundColor: "gray",
                        color: "white"
                    }}>
                        {location.name}
                    </div>;
                })}
            </div>
        </div>
        <div className="w-full" style={{ minHeight: "200px" }}>
            <div className="flex flex-column w-full">
                {vehicles?.map((v, i) => {
                    let fromLoc = v.fromLocation;
                    let toLoc = v.toLocation;
                    return getVehicleCard(v, i, fromLoc, toLoc, locPercent);
                })}
            </div>
        </div>
    </div>
    )
}
